"use client";
import type { Prisma } from "@-/prisma";
import { createContext } from "react";
import type { LeadInclude } from "./include";

export type LeadLayoutContext = {
  lead: Prisma.LeadGetPayload<{ include: LeadInclude }>;
};

const LayoutContext = createContext<LeadLayoutContext>(null!);

export default LayoutContext;
